/* PILSNERISH OS — pz-sort (R6): click-to-sort for the little text tables (drop log, C:\SHOP dir listing).
 * Markup contract (any element with [data-pz-sort]):
 *   [data-pz-sort-head] ... <button data-sort-key="date" data-sort-first="desc" [data-sort-on="desc"]>
 *   [data-pz-sort-list] ... rows [data-sort-row] with data-k-<key>="value" (numbers sort as numbers),
 *                          [data-sort-pin] rows always stay first (NEXT DROP), in their original order.
 *   optional [data-pz-sort-note] gets a short text of the current order.
 * A header button sorts by its key; pressing it again flips asc/desc. The active button carries data-sort-on
 * (CSS draws the arrow) and aria-pressed; a table header cell gets aria-sort. Ties keep the original order.
 */
(function () {
  'use strict';
  var w = window, d = document;
  if (w.__pzSort) return;
  w.__pzSort = true;

  function num(v) { return v !== '' && v != null && !isNaN(v) ? parseFloat(v) : null; }

  function init(root) {
    if (root.__pzSortOn) return;
    var head = root.querySelector('[data-pz-sort-head]');
    var list = root.querySelector('[data-pz-sort-list]');
    if (!head || !list) return;
    root.__pzSortOn = true;
    var btns = [].slice.call(head.querySelectorAll('[data-sort-key]'));
    var note = root.querySelector('[data-pz-sort-note]');
    var rows = [].slice.call(list.querySelectorAll('[data-sort-row]'));
    rows.forEach(function (r, i) { r.__pzIdx = i; });
    var key = null, dir = 'desc';
    btns.forEach(function (b) { if (b.hasAttribute('data-sort-on')) { key = b.getAttribute('data-sort-key'); dir = b.getAttribute('data-sort-on') || 'desc'; } });

    function label(b) { return (b.getAttribute('data-sort-label') || b.textContent || '').replace(/\s+/g, ' ').trim(); }
    function paint() {
      btns.forEach(function (b) {
        var on = b.getAttribute('data-sort-key') === key;
        if (on) b.setAttribute('data-sort-on', dir); else b.removeAttribute('data-sort-on');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var name = label(b);
        b.setAttribute('aria-label', 'Sort by ' + name.toLowerCase() + (on ? (dir === 'asc' ? ', ascending' : ', descending') : ''));
        var th = b.closest('th');
        if (th) { if (on) th.setAttribute('aria-sort', dir === 'asc' ? 'ascending' : 'descending'); else th.removeAttribute('aria-sort'); }
      });
      if (note && key) {
        var b = btns.filter(function (x) { return x.getAttribute('data-sort-key') === key; })[0];
        note.textContent = key === 'date' ? (dir === 'desc' ? 'NEWEST FIRST' : 'OLDEST FIRST') : 'BY ' + label(b).toUpperCase() + (dir === 'asc' ? ' \u25B2' : ' \u25BC');
      }
    }
    function sort() {
      var k = 'data-k-' + key;
      var vals = rows.map(function (r) { return r.getAttribute(k) || ''; });
      var numeric = vals.every(function (v) { return num(v) !== null; });
      var sorted = rows.slice().sort(function (a, b) {
        var x = a.getAttribute(k) || '', y = b.getAttribute(k) || '', c;
        if (numeric) c = num(x) - num(y);
        else c = x.localeCompare(y, undefined, { numeric: true, sensitivity: 'base' });
        if (dir === 'desc') c = -c;
        return c || a.__pzIdx - b.__pzIdx;
      });
      var pins = [].slice.call(list.querySelectorAll(':scope > [data-sort-pin]'));
      var frag = d.createDocumentFragment();
      pins.concat(sorted).forEach(function (r) { frag.appendChild(r); });
      list.appendChild(frag);
      root.dispatchEvent(new CustomEvent('pz:sorted', { bubbles: true, detail: { key: key, dir: dir } }));
    }
    head.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-sort-key]');
      if (!b || !head.contains(b)) return;
      e.preventDefault();
      var k = b.getAttribute('data-sort-key');
      if (k === key) dir = dir === 'asc' ? 'desc' : 'asc';
      else { key = k; dir = b.getAttribute('data-sort-first') || 'asc'; }
      sort();
      paint();
      if (w.PZ && w.PZ.scramble && !w.PZ.reduced) w.PZ.scramble(b, { mode: 'rgb', duration: 260 });
    });
    paint();
  }

  function scan(scope) { [].forEach.call((scope || d).querySelectorAll('[data-pz-sort]'), init); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  d.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  (w.PZ || (w.PZ = {})).sortInit = init;
})();
